module.exports = __webpack_public_path__ + "img/5f_r_iso@2x.524621d2.png";